import { ILocales } from '../constants/date-locale'

export const daysOfWeekKyrgyz = ['Дш', 'Шш', 'Шр', 'Бш', 'Жм', 'Иш', 'Жш']
export const daysOfWeekEnglish = ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su']
export const monthOfWeek = ['ПН', 'ВТ', 'СР', 'ЧТ', 'ПТ', 'СБ', 'ВС']

export const getLocaleDays = (defaultLanguage: ILocales) => {
  if (defaultLanguage === 'en') {
    return daysOfWeekEnglish
  } else if (defaultLanguage === 'ru') {
    return monthOfWeek
  } else {
    return daysOfWeekKyrgyz
  }
}
